module.exports = __webpack_public_path__ + "static/media/cross-light.d2d52840.svg";